// @flow

import { includes } from 'ramda'

import { PARENTAL_CONTROL_RESTRICTED_TAG } from '@alphaott/app-config'

export const isIncludesRestrictedTag = (tags: string[] = []): boolean => includes(PARENTAL_CONTROL_RESTRICTED_TAG, tags)
